export const CURRENT_VERSION = process.env.REACT_APP_VERSION || '';

export const HISTORY_MAX_LENGTH = 300;
export const DOCS_URL =
  'https://docs.influxdata.com/influxdb/v1.7/query_language/data_exploration/';
